




import { defineComponent, computed } from '@vue/composition-api';
import { storyapi } from '@/storyblok';

export default defineComponent({
  name: 'RichText',
  props: { blok: { type: Object, required: true } },
  setup(props) {
    return {
      content: computed(() => storyapi.richTextResolver.render(props.blok.content)),
    };
  },
});
